import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import moment from 'moment-timezone';
import { isResponse } from '../api/Request';
import { PRINT_PRECONFIG_IDS } from '../api/ConfigService';
export const overlayPrintPreconfigDates = (widgets, dates, fallback) => {
  if (dates !== null && dates !== void 0 && dates.fromDate && dates !== null && dates !== void 0 && dates.toDate) {
    return _objectSpread(_objectSpread({}, widgets), {}, {
      fromDate: dates.fromDate,
      toDate: dates.toDate
    });
  }

  const today = moment().format('YYYY-MM-DD');

  if (fallback === PRINT_PRECONFIG_IDS.idgComponents) {
    return _objectSpread(_objectSpread({}, widgets), {}, {
      fromDate: moment().subtract(14, 'days').format('YYYY-MM-DD'),
      toDate: today
    });
  }

  if (fallback === PRINT_PRECONFIG_IDS.planOfCare) {
    return _objectSpread(_objectSpread({}, widgets), {}, {
      fromDate: today,
      toDate: today
    });
  }

  return _objectSpread({}, widgets);
};
export const loadPrintPreconfigWidgets = async (configService, id) => {
  if (!configService) return null;
  const res = await configService.listPrintPreconfigs();
  if (!res || isResponse(res)) return null;
  const snap = res.find(p => p.id === id);
  return snap ? snap.widgets : null;
};
export const loadIdgComponentsPrintConfig = async (configService, dates) => {
  const widgets = await loadPrintPreconfigWidgets(configService, PRINT_PRECONFIG_IDS.idgComponents);
  if (!widgets) return null;
  return overlayPrintPreconfigDates(widgets, dates, PRINT_PRECONFIG_IDS.idgComponents);
};